import { EmblaCarousel } from '../vendor/embla.js';

class LkVariantGallery extends HTMLElement {
  connectedCallback() {
    if (this.embla) return;
    this.productRoot = this.closest('[data-product-root]');
    this.slides = [...this.querySelectorAll('.feature-media-item')];
    this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.visibleSlides = this.slides.filter(slide => !slide.hidden);
    this.embla = EmblaCarousel(this.querySelector('[data-gallery-viewport]'), {
      slides: this.visibleSlides, align: 'start', containScroll: false, duration: 20,
      startIndex: this.visibleSlides.findIndex(slide => slide.dataset.mediaId === this.dataset.initialMedia),
    });
    this.select = () => {
      const active = this.visibleSlides[this.embla.selectedScrollSnap()];
      if (!active) return;
      this.activeId = active.dataset.mediaId;
      this.querySelector('[data-gallery-status]').textContent = active.querySelector('img').alt;
      this.slides.forEach(slide => {
        const selected = slide === active;
        slide.inert = !selected;
        slide.setAttribute('aria-hidden', String(!selected));
        slide.classList.toggle('is-active', selected);
      });
      this.thumbnails.forEach(button => {
        const selected = button.dataset.galleryThumbnail === this.activeId;
        button.setAttribute('aria-pressed', String(selected));
        button.parentElement.classList.toggle('product-thumbnail-list-item--active', selected);
      });
    };
    this.goTo = (id) => {
      const index = this.visibleSlides.findIndex(slide => slide.dataset.mediaId === String(id));
      if (index >= 0) this.embla.scrollTo(index, this.motion.matches);
    };
    this.onMedia = (event) => {
      if (this.productRoot.contains(event.target)) this.goTo(event.detail.mediaId);
    };
    this.onVariant = (event) => {
      if (event.detail.productRootEl !== this.productRoot || !event.detail.variant) return;
      const id = String(event.detail.variant.featured_media?.id || '');
      this.querySelectorAll('[data-variant-only="true"]').forEach(el => { el.hidden = el.dataset.mediaId !== id; });
      this.visibleSlides = this.slides.filter(slide => !slide.hidden);
      this.embla.reInit({ slides: this.visibleSlides, startIndex: Math.max(0, this.visibleSlides.findIndex(slide => slide.dataset.mediaId === id)) });
      this.select();
    };
    this.onClick = (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.dataset.galleryThumbnail) this.goTo(button.dataset.galleryThumbnail);
      if (button.dataset.galleryZoom) {
        this.productRoot.querySelector('[x-ref="photoSwipeComponent"]').dispatchEvent(new CustomEvent('shapes:photoswipe:open', {
          detail: {
            index: this.visibleSlides.findIndex(slide => slide.dataset.mediaId === button.dataset.galleryZoom),
            mediaIds: this.visibleSlides.map(slide => slide.dataset.mediaId),
          },
        }));
      }
    };
    // The header's global Escape handler must not handle a gallery-modal close.
    this.onKeyUp = (event) => { if (event.key === 'Escape') event.stopPropagation(); };
    this.zoomContainer = this.productRoot.querySelector('#PhotoSwipeContainer');
    this.embla.on('select', this.select).on('reInit', this.select);
    this.addEventListener('click', this.onClick);
    this.addEventListener('keyup', this.onKeyUp);
    this.productRoot.addEventListener('shapes:product:mediachange', this.onMedia);
    document.addEventListener('theme:variant:change', this.onVariant);
    this.zoomContainer?.addEventListener('keyup', this.onKeyUp);
    this.classList.add('is-initialized');
    this.select();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keyup', this.onKeyUp);
    this.productRoot?.removeEventListener('shapes:product:mediachange', this.onMedia);
    document.removeEventListener('theme:variant:change', this.onVariant);
    this.zoomContainer?.removeEventListener('keyup', this.onKeyUp);
    this.embla?.destroy();
    this.embla = null;
  }
}

if (!customElements.get('lk-variant-gallery')) customElements.define('lk-variant-gallery', LkVariantGallery);
